import {
  AuthFlowComplete,
  AuthFlowId,
  AuthStepDefinition,
  AuthStepId,
  AuthStepRoute,
  AuthTransitionKey,
} from '../../models/auth-flow.models';

export const PVZ_PINCODE_STEP: AuthStepDefinition = {
  id: AuthStepId.ENTER_PINCODE,
  route: AuthStepRoute.Pincode,
  back: AuthStepId.ENTER_ON_PVZ_LINK,
  showLegalFooter: true,
  next: {
    [AuthFlowId.Pvz]: {
      [AuthTransitionKey.Default]: AuthFlowComplete.Complete,
    },
  },
};
